import { connect } from 'react-redux';
import { goBack, push } from 'redux-first-history';
import UnsignedLeaseWarning from './component';
import { closeNotification, showModalNotification } from '@common/actions/NotificationActions';
import paths from '@rental-manager/pathsManifest';
import { DEFAULT_ERROR } from '@rental-manager/constants/NotificationConstants';
import { saveRentalProtectionFeature } from '@rental-manager/actions/OnboardingActions';
import { logError } from '@zg-rentals/log-error';
import { ToggleFeatureWebApiHandler_toggleFeature } from '@zg-rentals/ts-rent-payment-client';

const mapStateToProps = (state, { propertyId }: Record<string, any>) => {
  const { rentalProtectionDisclaimers } = state.payments.landlord.onboarding[propertyId];
  return {
    propertyId,
    rentalProtectionDisclaimers,
  };
};

const mapDispatchToProps = (dispatch, { baseUrl, propertyId }) => ({
  skipRentalProtectionOnboarding: ({ featureName, on }) =>
    Promise.resolve()
      .then(() => ToggleFeatureWebApiHandler_toggleFeature({ resourceId: propertyId, featureName, on }))
      .then(() => dispatch(saveRentalProtectionFeature({ propertyId, rentGuarantee: false })))
      .then(() => dispatch(push(baseUrl + paths.onboarding.rentAmountPage)))
      .catch((err) => {
        logError({ error: err });
        dispatch(showModalNotification(DEFAULT_ERROR));
        return { error: true };
      }),
  onBack: () =>
    Promise.resolve()
      .then(() => dispatch(closeNotification()))
      .then(() => dispatch(goBack())),
  onClose: () =>
    Promise.resolve()
      .then(() => dispatch(closeNotification()))
      .then(() => dispatch(push(baseUrl + paths.onboarding.exitPaymentSetup))),
});

export default connect(mapStateToProps, mapDispatchToProps)(UnsignedLeaseWarning);
